import React, { useState } from "react";
import api from "@/lib/api";
import toast from "react-hot-toast";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

const ResetPasswordPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password) return toast.error("Enter a new password");
    try {
      setLoading(true);
      await api.post("/users/reset-password", { token, password });
      toast.success("Password reset. Please log in.");
      navigate("/login");
    } catch {
      toast.error("Reset failed. Link may have expired.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-blue-50">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md p-6 bg-white shadow-lg rounded-2xl"
      >
        <h1 className="mb-2 text-2xl font-bold text-center text-blue-900">
          Choose a new password
        </h1>

        <label className="block mb-1 text-sm font-semibold text-blue-900">
          New Password
        </label>
        <div className="relative mb-6">
          <input
            type={show ? "text" : "password"}
            className="w-full px-4 py-2 pr-10 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="********"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 px-3 text-gray-600"
            onClick={() => setShow((s) => !s)}
            aria-label={show ? "Hide password" : "Show password"}
          >
            {show ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-2 font-semibold text-white transition bg-blue-900 rounded hover:bg-blue-800 disabled:opacity-70"
        >
          {loading ? "Updating..." : "Reset Password"}
        </button>

        <div className="mt-6 text-sm text-center">
          <Link className="text-blue-700 hover:underline" to="/login">
            Back to login
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ResetPasswordPage;
